import {BlockEmbed} from './block';

class GoogleMap extends BlockEmbed {
  static create(value) {
    const node = super.create(value);
    node.setAttribute('contenteditable', false);
    node.setAttribute('frameborder', '0');
    node.setAttribute('allowfullscreen', true);
    node.setAttribute('scrolling', 'no');
    node.setAttribute('width', '100%');
    node.setAttribute('height', '480');
    node.setAttribute('src', value);
    node.classList.add('flex-width');
    return node;
  }
  
  static value(domNode) {
    return domNode.getAttribute('src');
  }
  
  index() {
    return 0;
  }
}
GoogleMap.tagName = 'IFRAME';
GoogleMap.blotName = 'googleMap';
GoogleMap.className = 'ql-map';

export default GoogleMap;